import React from 'react';

const SkeletonLoading = ({ type, count = 1 }) => {
  const renderSkeleton = () => {
    switch (type) {
      case 'product':
        return (
          <div className="animate-pulse bg-white rounded-lg overflow-hidden shadow-sm border border-gray-100 h-[350px]">
            <div className="bg-gray-200 h-[200px] w-full"></div>
            <div className="p-4 space-y-3">
              <div className="h-4 bg-gray-200 rounded w-3/4"></div>
              <div className="h-3 bg-gray-200 rounded w-1/2"></div>
              <div className="h-6 bg-gray-200 rounded w-1/3 mt-2"></div>
              <div className="flex space-x-2 mt-2">
                {[...Array(4)].map((_, i) => (
                  <div key={i} className="h-4 w-4 bg-gray-200 rounded-full"></div>
                ))}
              </div>
            </div>
          </div>
        );
      
      case 'productDetail':
        return (
          <div className="animate-pulse grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="space-y-4">
              <div className="bg-gray-200 h-[400px] w-full rounded-lg"></div>
              <div className="flex space-x-2">
                {[...Array(4)].map((_, i) => (
                  <div key={i} className="bg-gray-200 h-20 w-20 rounded-md"></div>
                ))}
              </div>
            </div>
            <div className="space-y-4">
              <div className="h-8 bg-gray-200 rounded w-3/4"></div>
              <div className="h-4 bg-gray-200 rounded w-1/2"></div>
              <div className="h-6 bg-gray-200 rounded w-1/3 mt-4"></div>
              <div className="h-10 bg-gray-200 rounded w-full mt-4"></div>
              <div className="h-12 bg-gray-200 rounded w-full mt-6"></div>
              <div className="h-12 bg-gray-200 rounded w-full mt-2"></div>
            </div>
          </div>
        );
      
      case 'address':
        return (
          <div className="animate-pulse p-4 border rounded-lg">
            <div className="h-5 bg-gray-200 rounded w-1/3 mb-3"></div>
            <div className="h-4 bg-gray-200 rounded w-full mb-2"></div>
            <div className="h-4 bg-gray-200 rounded w-2/3"></div>
          </div>
        );

      case 'filter':
        return (
          <div className="animate-pulse space-y-4">
            <div className="h-8 bg-gray-200 rounded w-full"></div>
            {[...Array(5)].map((_, i) => (
              <div key={i} className="h-10 bg-gray-200 rounded w-full"></div>
            ))}
          </div>
        );

      default:
        return <div className="animate-pulse h-10 bg-gray-200 rounded w-full"></div>;
    }
  };

  return (
    <>
      {[...Array(count)].map((_, index) => (
        <div key={index}>{renderSkeleton()}</div>
      ))}
    </>
  );
};

export default SkeletonLoading;